module.exports = __webpack_public_path__ + "static/media/gummy-yellow.98d58775.png";